import React from 'react'
import {Header, List} from 'semantic-ui-react'

const PrioritizeMockResponses = () => {
  return (
    <div className='doc-section'>
      <Header as='h2'>Prioritize Mock Responses</Header>
      <p>
        Given a resource will have 1-N possible responses to evaluate when determining what to return
        it's going to be necessary to manage the order these responses are evaluated. To do so you will
        have to set the weight for each response until you see the response list is in the order
        you intend the mock to evaluate them. The first response that is either explicitly active or
        is activated via a script will be the response that is returned.
      </p>
      <Header as='h3' dividing>Steps:</Header>
      <List relaxed>
        <List.Item>1. Navigate to a service/version/environment/resource combo you plan to work with.</List.Item>
        <List.Item>2. Click on the "Responses" tab</List.Item>
        <List.Item>3. Click the "Edit" symbol for the response you intend to work with</List.Item>
        <List.Item>4. Change the weight of the response to reflect where you want the response to reside in the
          list.</List.Item>
        <List.Item>5. You'll need to review the weights of other responses to order the way you prefer.</List.Item>
      </List>
    </div>
  )
}

export {PrioritizeMockResponses}

export default PrioritizeMockResponses